module.exports = [{"name":"bread","color":"brown","icon":"N/A"},{"name":"chicken","color":"blue","icon":"N/A"},{"name":"broccoli","color":"green","icon":"N/A"},{"name":"flax seeds","color":"green","icon":"N/A"}]


//////////////////
// WEBPACK FOOTER
// ./src/openingredients.json
// module id = 49
// module chunks = 0